<template>
  <div
    id="milesNBonusLogin"
    class="modal fade s-modal-miles-n-bonus"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div v-show="currentStep === 0" class="modal-content">
        <div class="modal-header">
          <LazyImage
            v-if="milesNBonusLoginImage"
            :image="milesNBonusLoginImage" />
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close">
            <i class="icon-close-light"></i>
          </button>
        </div>
        <form autocomplete="off" @submit.prevent="onSubmitForm">
          <div class="modal-body">
            <Loader v-if="isLoading" display="absolute"></Loader>
            <Alert
              v-if="errorMsgs.length"
              type="danger"
              :messages="errorMsgs" />

            <div class="logo">
              <LazyImage v-if="milesNBonusLogo" :image="milesNBonusLogo" />
            </div>

            <div class="title">
              <span>{{ dictionary.milesNBonusLoginStepTitle }}</span>
            </div>

            <div class="row">
              <div class="col">
                <label for="milesNBonusCode" class="form-label">
                  {{ dictionary.milesNBonusLoginStepIDLabel }}
                </label>
                <input
                  id="milesNBonusCode"
                  v-model.trim="milesNBonusCode"
                  class="form-control"
                  :class="{ 'has-error': v$.milesNBonusCode.$error }"
                  name="milesNBonusCode"
                  :placeholder="dictionary.milesNBonusLoginStepIDPlaceholder"
                  type="text"
                  maxlength="9"
                  :readonly="isLoading" />
                <div v-if="v$.milesNBonusCode.$error">
                  <div
                    v-if="v$.milesNBonusCode.required.$invalid"
                    class="error">
                    {{ dictionary.milesNBonusLoginStepCodeRequired }}
                  </div>
                  <div v-if="v$.milesNBonusCode.numeric.$invalid" class="error">
                    {{ dictionary.milesNBonusLoginStepCodeInvalid }}
                  </div>
                  <div
                    v-if="v$.milesNBonusCode.minLength.$invalid"
                    class="error">
                    {{ dictionary.milesNBonusLoginStepCodeLengthInvalid }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="mb-10">
              <div id="g-recaptcha-mbModal"></div>
              <template v-if="v$.reCaptchaResponse.$error">
                <div
                  v-if="v$.reCaptchaResponse.required.$invalid"
                  class="error">
                  {{ dictionary.reCaptchaRequired }}
                </div>
              </template>
            </div>
            <button
              type="submit"
              class="btn btn-primary btn-full-width"
              :disabled="isLoading">
              {{ dictionary.milesNBonusLoginButtonLabel }}
            </button>
          </div>
        </form>
      </div>

      <template v-if="currentStep === 1">
        <div v-if="responseData?.redeemAllowed" class="modal-content">
          <div class="modal-header">
            <LazyImage v-if="responseData.image" :image="responseData.image" />
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close">
              <i class="icon-close-light"></i>
            </button>
          </div>
          <div class="modal-body">
            <Loader v-if="isLoading" display="absolute"></Loader>
            <Alert
              v-if="errorMsgs.length"
              type="danger"
              :messages="errorMsgs" />

            <div class="logo">
              <LazyImage v-if="responseData.logo" :image="responseData.logo" />
            </div>

            <div class="subtitle">
              <span>
                {{ responseData.text }}
              </span>
            </div>

            <div class="miles-and-bonus__block">
              <!-- ID -->
              <div class="miles-and-bonus__block-item col">
                <span class="title">
                  {{ dictionary.milesNBonusIDPrefix }}
                </span>
                <span class="description">
                  {{ milesNBonusCode }}
                </span>
              </div>
              <!-- Tier -->
              <div class="miles-and-bonus__block-item col">
                <span class="title">
                  {{ dictionary.milesNBonusSuccesTierLabel }}
                </span>
                <div class="description d-flex justify-content-between">
                  <span>
                    {{ responseData.tier }}
                  </span>
                  <LazyImage
                    v-if="responseData.tierCardLogo"
                    :image="responseData.tierCardLogo" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="bottomControls">
              <ul class="dots">
                <li class="circle active" @click="goToStep(1)"></li>
                <li
                  v-for="dot in journeyData.length"
                  :key="dot"
                  class="circle"
                  @click="goToStep(dot + 1)"></li>
              </ul>
              <div class="nextBtn">
                <button
                  type="submit"
                  class="btn btn-primary bold"
                  @click="nextStep"></button>
              </div>
            </div>
          </div>
        </div>
        <template v-else>
          <div class="modal-content" style="min-height: unset">
            <div class="modal-header">
              <LazyImage
                v-if="milesNBonusLoginImage"
                :image="milesNBonusLoginImage" />
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close">
                <i class="icon-close-light"></i>
              </button>
            </div>
            <div class="modal-body">
              <Alert
                type="warning"
                :messages="[
                  dictionary.milesNBonusLoginNotRedeemAllowedAlert,
                ]" />
            </div>
          </div>
        </template>
      </template>

      <template v-for="(joyrney, index) in journeyData" :key="joyrney.id">
        <div v-if="currentStep === index + 2" class="modal-content">
          <div class="modal-header">
            <div class="new">{{ dictionary.milesNBonusTagLabel }}</div>
            <LazyImage v-if="joyrney.image" :image="joyrney.image" />

            <button
              v-if="!(currentStep === journeyData.length + 1)"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close">
              <i class="icon-close-light"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="text">
              <p class="bold">
                {{ joyrney.title }}
              </p>
              <p>
                {{ joyrney.description }}
              </p>
            </div>
            <div v-if="joyrney.info" style="display: flex; gap: 20px">
              <div
                class="col"
                style="
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  justify-content: space-between;
                  gap: 4px;
                  border: 1px solid #dddddd;
                  border-radius: 4px;
                  padding: 10px 20px 10px 0;
                ">
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 4px;
                  ">
                  <div style="width: 50px; height: 50px">
                    <IdeaLottie width="20" />
                  </div>
                  <span style="font-size: 13px">
                    {{ joyrney.info.title }}
                  </span>
                </div>
                <span class="bold" style="font-size: 18px">
                  {{ joyrney.info.text }}
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="currentStep === journeyData.length + 1"
              type="button"
              class="btn btn-primary btn-full-width close-btn"
              data-bs-dismiss="modal">
              {{ dictionary.milesNBonusContinueButtonLabel }}
            </button>

            <div class="bottomControls">
              <ul class="dots">
                <li class="circle" @click="goToStep(1)"></li>
                <li
                  v-for="dot in journeyData.length"
                  :key="dot"
                  class="circle"
                  :class="{ active: currentStep === dot + 1 }"
                  @click="goToStep(dot + 1)"></li>
              </ul>
              <div
                v-if="!(currentStep === journeyData.length + 1)"
                class="nextBtn">
                <button
                  type="button"
                  class="btn btn-primary bold"
                  @click="nextStep"></button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
  <MilesNBonusOTPModal
    ref="otpModal"
    :wrong-code="wrongCode"
    :is-loading="isLoading"
    :error-msgs="errorMsgs"
    @reset-otp="resetOTP"
    @request-otp="requestOTP"
    @validate-otp="validateOTP" />
</template>

<script>
import * as lib from './../../lib/lib'
import axios from 'axios'
import useVuelidate from '@vuelidate/core'
import { minLength, numeric, required } from '@vuelidate/validators'
import Alert from './../components/common/Alert.vue'
import Loader from './../components/common/Loader.vue'
import LazyImage from './../components/common/LazyImage.vue'
import IdeaLottie from './../components/lotties/Idea.vue'
import { Modal } from 'bootstrap'
import MilesNBonusOTPModal from './../components/MilesNBonusOTPModal.vue'
import constants from './../../lib/constants'

export default {
  components: { LazyImage, Loader, Alert, IdeaLottie, MilesNBonusOTPModal },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      isLoading: false,
      errorMsgs: [],

      reCaptchaResponse: '',
      reCaptchaWidget: null,

      wrongCode: false,
      modalMilesNBonusOTP: null,
      modalMilesNBonusLogin: null,
      milesNBonusLoggedIn: false,

      currentStep: 0,
      milesNBonusCode: '',
      // tier: '',
      // miles: '',
      responseData: null,
      journeyData: [],
      milesNBonusLogo: null,
      milesNBonusLoginImage: null,

      lang: 'en',
    }
  },
  validations() {
    return {
      milesNBonusCode: {
        required,
        numeric,
        minLength: minLength(9),
      },
      reCaptchaResponse: {
        required,
      },
    }
  },

  mounted() {
    const { journeyData, milesNBonusLogo, milesNBonusLoginImage } =
      lib.getData('milesNBonusData')
    this.journeyData = journeyData
    this.milesNBonusLogo = milesNBonusLogo
    this.milesNBonusLoginImage = milesNBonusLoginImage
    this.milesNBonusLoggedIn = this.configuration.milesNBonusLoggedIn

    this.lang = lib.getLocaleFromLangAttr()

    this.modalMilesNBonusLogin = new Modal(
      document.getElementById('milesNBonusLogin')
    )

    document
      .getElementById('milesNBonusLogin')
      .addEventListener('hidden.bs.modal', this.handleModalClose)

    this.setEventListeners()

    this.$nextTick(() => {
      this.modalMilesNBonusOTP = new Modal(
        document.getElementById('milesNBonusOTP')
      )
    })
  },
  methods: {
    setEventListeners() {
      document.addEventListener('recaptcha-ready', () => {
        this.iniReCaptcha()
      })

      document.addEventListener('showMilesNBonusModal', () => {
        this.modalMilesNBonusLogin.show()
      })

      document.addEventListener('milesNBonusLogStatus', (e) => {
        this.milesNBonusLoggedIn = e.detail.logStatus
      })

      document.addEventListener('showMilesNBonusOTP', () => {
        this.modalMilesNBonusOTP.show()
      })
      document.addEventListener('hideMilesNBonusOTP', () => {
        this.$refs.otpModal.reset()
        this.modalMilesNBonusOTP.hide()
      })
      document.addEventListener(
        'wrongOTP',
        (e) => (this.wrongCode = e.detail.wrongCode)
      )
      document.addEventListener(
        'milesNBonusLoading',
        (e) => (this.isLoading = e.detail.loading)
      )
    },

    resetOTP() {
      this.wrongCode = false
    },

    callbackReCaptcha(response) {
      this.reCaptchaResponse = response
    },

    expiredCallbackReCaptha() {
      this.reCaptchaResponse = ''
    },

    iniReCaptcha() {
      document.getElementById('g-recaptcha-mbModal').innerHTML = ''

      const grecaptcha = window.grecaptcha

      this.reCaptchaWidget = grecaptcha.render('g-recaptcha-mbModal', {
        sitekey: this.configuration.reCaptchaPublicKey,
        callback: this.callbackReCaptcha,
        'expired-callback': this.expiredCallbackReCaptha,
      })
    },

    resetReCaptcha() {
      this.reCaptchaResponse = ''
      window.grecaptcha.reset(this.reCaptchaWidget)
    },

    handleModalClose() {
      this.currentStep = 0
      this.resetReCaptcha()
      if (this.milesNBonusLoggedIn) {
        if (this.isHomePage() || this.isPersonalPage()) {
          return
        }
        location.reload()
      }
    },

    isHomePage() {
      const { homePage } = constants.nodeTypeAlias
      return this.configuration.nodeTypeAlias === homePage
    },

    isPersonalPage() {
      if (lib.getData('bookingData')) {
        const { configuration } = lib.getData('bookingData')
        const { personalPage } = constants.nodeTypeAlias
        return configuration.nodeTypeAlias === personalPage
      }
      return false
    },

    onSubmitForm() {
      this.v$.$validate()

      if (this.v$.$invalid) {
        return false
      }

      if (this.isLoading) {
        return false
      }

      this.isLoading = true

      const postData = { code: this.milesNBonusCode }
      axios
        .post(this.configuration.endpointMilesNBonusLogin, postData)
        .then((response) => {
          const { errorMessages, data } = response.data

          if (errorMessages.length) {
            this.handleError(errorMessages)
            return false
          }

          this.responseData = data

          this.handleSuccess()
          document.dispatchEvent(
            new CustomEvent('milesNBonusLogStatus', {
              detail: {
                logStatus: true,
                id: this.milesNBonusCode,
                miles: this.responseData.miles,
                redeemAllowed: this.responseData.redeemAllowed,
              },
            })
          )
          this.milesNBonusLoggedIn = true
          this.nextStep()
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    requestOTP() {
      document.dispatchEvent(new CustomEvent('requestOtp'))
    },

    validateOTP(OTPcode) {
      document.dispatchEvent(
        new CustomEvent('validateOtp', {
          detail: {
            otpCode: OTPcode,
          },
        })
      )
    },

    goToStep(step) {
      this.currentStep = step
    },

    nextStep() {
      this.currentStep += 1
    },

    handleSuccess() {
      this.isLoading = false
      this.errorMsgs = []
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },
  },
}
</script>
